module.exports = __webpack_public_path__ + "static/img/3.6f64278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/mikse/3.jpg
// module id = BKLP
// module chunks = 0